import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const CUSTOM_FIELD_SCHEMA = Object.freeze({
    KEY: '',
    VALUE: '',
  }),
  RECORD = generateSchema(CUSTOM_FIELD_SCHEMA),
  KEYS: any = generateKeys(CUSTOM_FIELD_SCHEMA);

export class CustomField extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get key(): string {
    return this.get(KEYS.KEY);
  }

  get value(): string {
    return this.get(KEYS.VALUE);
  }
}
